<template>
	<div class="header"  :class="show ? 'h5' : scrollHeight>600?'wbg':currNav=='business'?'wbg':''">
		<div class="header-content Gwidth flex items-center space-between" >
			<div class="left-content">
			<div class="logo">
				<router-link to="/">
					<img src="@/assets/img/logo.png" alt="logo" />
				</router-link>
			</div>
			<div class="navigation" v-if="!show">
				<div class="item">
					<div class="txt" :class="{ act: currNav == '/'||currNav == 'home' }" @click="toNavTab('/home.html')"><a href="/home.html">首页</a></div>
				</div>
				<div class="item">
					<div class="txt" :class="{ act: currNav == 'product'||currNav == 'products' }" >产品服务</div>
					<div class="ulitem">
						<div class="nat" :class="{ act: currNav == 'product'}" @click="toNavTab('/product.html')"><a href="/product.html">软件产品</a></div>
						<div class="nat" :class="{ act: currNav == 'products'}" @click="toNavTab('/products.html')"><a href="/products.html">硬件产品</a></div>
					</div>
				</div>
				<div class="item">
					<div class="txt" :class="{ act: currNav == 'recruitment'||currNav == 'recruitments' }" >业务招募</div>
					<div class="ulitem">
						<div class="nat" :class="{ act: currNav == 'recruitment'}" @click="toNavTab('/recruitment.html')"><a href="/recruitment.html">小盒子</a></div>
						<div class="nat" :class="{ act: currNav == 'recruitments'}" @click="toNavTab('/recruitments.html')"><a href="/recruitments.html">大节点</a></div>
					</div>
				</div>
				<div class="item">
					<!-- <div class="txt" :class="{ act: currNav == 'docs' }" @click="toOpen">帮助中心</div> -->
					<div class="txt" :class="{ act: currNav == 'help' }" @click="toNavTab('/help.html')"><a href="/help.html">帮助中心</a></div>
				</div>
				<div class="item">
					<div class="txt" :class="{ act: currNav == 'down' }" @click="toNavTab('/down.html')"><a href="/down.html">下载中心</a></div>
				</div>
				<div class="item">
					<div class="txt" :class="{ act: currNav == 'about' }" @click="toNavTab('/about.html')"><a href="/about.html">关于我们</a></div>
				</div>
			</div>
		</div>
			<div class="right-content flex items-center">	
				<div class="need" v-if="userName">			
				
				<div class="user"></div>
				<div class="name">{{userName}}</div>
				<div class="lls">|</div>
				<div class="dl blur" @click="toOpens('https://partner.biandianyun.com')">控制台</div>
				</div>			
				<div class="need" v-else>
					<div class="dl" @click="toOpens('https://partner.biandianyun.com')">登录</div>
					<div class="btn"  @click="toOpens('https://partner.biandianyun.com')">立即注册</div>
					<!-- <router-link to="/">沟通需求</router-link> -->
				</div>
				<div class="menu">
				<i class="el-icon-s-fold" @click="mshow = !mshow"></i>
			</div>
			</div>

			<!-- H5 -->
			
			
		</div>

		<transition name="el-fade-in-linear">
				<ul class="m-nav" v-show="mshow" @click="mshow = false">
					<li class="nav-item" :class="{ act: currNav == 'home' }">
						<router-link to="/home.html">首页</router-link>
					</li>
					<li class="nav-item" :class="{ act: currNav == 'product' }">
						<router-link to="/product.html">软件产品 </router-link>
					</li>
					<li class="nav-item" :class="{ act: currNav == 'products' }">
						<router-link to="/products.html">硬件产品</router-link>
					</li>
					<li class="nav-item" :class="{ act: currNav == 'recruitment' }">
						<router-link to="/recruitment.html">小盒子业务</router-link>
					</li>
					<li class="nav-item" :class="{ act: currNav == 'recruitments' }">
						<router-link to="/recruitments.html">大节点业务</router-link>
					</li>
					<li class="nav-item" :class="{ act: currNav == 'docs' }">
						<div @click="toOpen" class="link">帮助中心</div>
					</li>
					<li class="nav-item" :class="{ act: currNav == 'down' }">
						<router-link to="/down.html">下载</router-link>
					</li>
					<li class="nav-item" :class="{ act: currNav == 'about' }">
						<router-link to="/about.html">关于我们</router-link>
					</li>
				</ul>
			</transition>
	</div>
</template>
<script>
	import {mapState } from "vuex";
	import Cookies from 'js-cookie'
	export default {
		name:"header_bdy",
		data() {
			return {
				show: false,
				mshow:false,
				userName:'',
				scrollHeight:0
			};
		},
		mounted(){	
			window.addEventListener('scroll', this.handleScroll);
			if (this._isMobile()) {
			this.show = true;
			} else {
			this.show = this.$store.getters.phone;
			}
		},
		watch: {
			"$store.getters.phone": function (val) {
			this.show = val;
			},
			deep: true,
			immediate: true,
		},
		computed: {
			...mapState(["currNav"]),
		},


  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

		created(){
			this.getUser()
		},
		methods:{
			handleScroll() {
      this.scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
			getUser(){
				this.userName=Cookies.get('bdy-User')
			},
			toNavTab(val){
				this.$store.commit("ChangeCurrNav",val);
				console.log(this.$route.path);
				if (val == this.$route.path) {
					return;
				}				
				// this.$router.push({ path: val });
			},
			toOpen(){
				this.$store.commit("ChangeCurrNav", 'docs');
				window.open("https://docs.biandianyun.com")
			},
			toOpens(val){
				window.open(val)
			},
			_isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pod|iPhone|iPod|ios|Android|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
		}
	};
</script>
<style lang="scss" scoped>

	.header {
		background: #ffffff00;
		backdrop-filter: blur(15px);	
		width: 100%;
		display: flex;
        align-items: center;
		// border-bottom: 1px solid #c8c9cc;
		position: fixed;
		.left-content{
			
			display: flex;
			align-items: center;
		.logo {
			font-size: 0;
			margin-right: 130px;
			img {
				width: 190px;
				height: auto;
			}
		}
		.navigation{
			display: flex;
			align-items: center;
			margin-left: 70px;
			.item{
				padding: 17px;
				cursor: pointer;
				position: relative;
				.txt{
					font-size: 16px;
					color: #000000;
					white-space: nowrap;
					a{
						color: #000000;
					}
				}
				.txt:hover{
					color: #1373FF;
					
				}
				.act{
					color: #1373FF;
				}
				.ulitem{
					position: absolute;
					display: none;
					top:48px;
					left: 50%;
					transform: translateX(-50%);
					background: #F8F9FC;
					height: 96px;
					width: 96px;
					box-shadow: 1px 5px 10px #e3ebfb;
					.nat{
						display: flex;
						align-items: center;
						justify-content: center;
						height: 48px;
						font-size: 14px;
					}
					a{
						color: #000000;
					}
					.act,.nat:hover{
						background: #ffffff;
						color: #1373FF;
						a{
							color: #1373FF;
						}
					}
				}
			}
			.item:hover{
				.ulitem{
					display: block;
				}
			}
		}
		.nav-item {
			a {
				font-size: 16px;
				font-weight: 400;
				color: #1d2129;
			}
			&.active {
				a {
					font-weight: 600;
					color: #1373FF;
				}
			}
		}
		}
		.right-content {
			.tel {
				background: url(@/assets/images/icon-phone.png) left center
					no-repeat;
				background-size: 24px 24px;
				padding-left: 26px;
				a {
					font-size: 18px;
					font-weight: 400;
					color: #1d2129;
				}
			}
			.need {
				display: flex;
				align-items: center;
				.dl{
					color: #000000;
					font-weight: 500;
					font-size: 16px;
					cursor: pointer;
					white-space: nowrap;
				}
				.blur{
					color: #1373FF;
				}
				.user{
					border-radius: 100%;
					width: 24px;
					height: 24px;
					margin-left: 6px;
					background: #d6eaff;
				}
				.name{
					font-size: 14px;
					margin-left: 6px;
				}
				.lls{
					margin: 0 12px;
				}
				.btn{
					background: #276BFF;
					box-shadow: 5px 5px 10px #D5E6FF;
					color: #ffffff;
					border-radius: 18px;
					width: 104px;
					height: 35px;
					font-size: 16px;
					margin-left: 32px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}
				img{
					width: 70px;
					height: 43px;
				}
				a {
					display: inline-block;
					background: #2b6bff;
					font-size: 14px;
					font-weight: 400;
					color: #ffffff;
					text-align: center;
				}
			}
		}
	}
	.wbg{
		background: #ffffff;
	}
	.h5{
		.left-content{
			.logo{
				img{
					width: 105px;
				}
			}
		}
		.right-content{
			.need{
				.dl{
					font-size: 14px;
				}
				.btn{
					margin-left: 10px;
					font-size: 14px;
					width: 88px;
					height: 32px;
				}
			}
			.menu{
				margin-left: 10px;
			}
		}
	}

	@media screen and (min-width: 0px) {
		.header {
			padding: 10px 0;
			height: 65px;
			z-index: 999;
			box-sizing: border-box;
			.left-content .logo{
				margin: 0;
			}
			nav,
			.tel,
			.need {
				display: none;				
			}
			.need{
				.dl{
					font-size: 8px;
				}
			}
			.menu {
				display: block;
				margin-left: 24px;
				font-size: 30px;
			}
			.link{
				line-height: 50px;
			}
			.m-nav {
				position: fixed;
				top: 100%;
				left: 0;
				z-index: 99999;
				width: 100%;
				height: calc(100vh - 65px);
				overflow: hidden;
				background-color: #ffffff;
				text-align: center;
				li {
					border-bottom: 1px solid #eeeeee;
					a {
						line-height: 50px;
						color: #000000;
					}
					
				}
			}
			.act{
					a{
						color: #1373FF !important;
					}
					}
		}
	}
	@media screen and (min-width: 760px) {
		.header {
			height: 80px;
			padding: 23px 0;
			box-sizing: border-box;
			nav {
				display: block;
				ul {
					li {
						a {
							padding: 0 25px;
						}
					}
				}
			}
			.menu {
				display: none;
			}
		}
	}
	@media screen and (min-width: 820px) {
		.header {
			.need {
				display: block;
				a {
					width: 84px;
					height: 36px;
					border-radius: 19px;
					line-height: 36px;
				}
			}
		}
	}
	@media screen and (min-width: 1100px) {
		.header {
			.tel {
				display: block;
			}
			.need {
				margin-left: 15px;
			}
		}
	}
	@media screen and (min-width: 1300px) {
		.header {
			&-content {
				.need {
					margin-left: 40px;
					a {
						width: 104px;
						height: 36px;
						border-radius: 19px;
						line-height: 36px;
					}
				}
			}
		}
	}
</style>
